import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter as Router } from 'react-router-dom';
import { Provider as StateProvider } from 'react-redux';

// import AOS from "aos";

import * as serviceWorker from './serviceWorker';
import { getStore, setStore } from './services/store';
import { setConfig } from './utilities/config';
import App from './app';
import bootstrap from './boot';

// import 'aos/dist/aos.css';
import 'ui/themes/styles.scss';
import 'react-medium-image-zoom/dist/styles.css';

setConfig();
setStore();

const AppContainer = () => {
  // React.useEffect(() => {
  //   AOS.init();
  // }, []);

  return (
    <StateProvider store={getStore()}>
      <Router>
        <App />
      </Router>
    </StateProvider>
  );
};

ReactDOM.render(<AppContainer />, document.getElementById('root'));

bootstrap();
serviceWorker.unregister();
